import { objectToQueryString } from "../ApiClient";
import { parseAllowedSearchParams } from "./urls";
export function pushObjectToState(objectToSave) {
    // Detect and restore url tracking parameters utm_*
    const currentParams = parseAllowedSearchParams();
    let queryUrl = objectToQueryString({ ...objectToSave, ...currentParams });
    if (queryUrl !== '')
        queryUrl = `?${queryUrl}`;
    window.history.replaceState(objectToSave, "", queryUrl !== '' ? queryUrl : location.pathname);
}
